import gql from 'graphql-tag'

export const fetchOrganizationsSelect = () => {
	return {
		query: gql`
			{
				organizations: organizations(
					where: { active: { _eq: true } }
					order_by: { name: asc }
				) {
					id
					name
				}
			}
		`
	}
}
